<template>
  <article class="row border-bottom mt-1">
    <div class="col">
      <div class="row mx-0">
        <div class="col">
          <div class="row">
            <div class="col-auto">
              <img
                src="@/assets/avatar.jpg"
                style="width: 48px"
                class="rounded-circle"
              />
            </div>
            <div class="col px-0">
              <div class="d-flex flex-column bd-highlight">
                <div class="d-flex justify-content-between">
                  <h5 class="card-title my-0">Taha Malaldır</h5>
                  <div class="dropdown">
                    <button
                      class="btn py-0"
                      type="button"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-h"></i>
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <li>
                        <div class="dropdown-item">
                          <i class="fas fa-trash me-2"></i>Sil
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <p class="card-text text-break pe-3 lh-sm">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit
                  iure delectus suscipit autem neque, aperiam quae cupiditate
                  vero excepturi voluptatum officiis facere, magni ratione et.
                  Ipsam sit porro ab quidem officiis, dolor esse modi minus quam
                  eos libero nulla atque, provident fuga at, nobis impe
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row py-0 mx-0">
        <div class="col">
          <div class="">
            <!-- <img src="@/assets/GL_bg.jpg" style="width: 100%" /> -->
            <image-dialog :imagePath="imagePath"></image-dialog>
          </div>
        </div>
      </div>
      <div class="row py-1 mx-0">
        <div class="col">
          <button
            class="btn"
            :class="{ 'btn-info': isLike }"
            type="button"
            style="width: 100%"
            @click="paylasimBegen()"
          >
            <i class="fas fa-thumbs-up mx-2"></i>123
          </button>
        </div>
        <div class="col">
          <button
            class="btn"
            type="button"
            style="width: 100%"
            @click="showComment()"
          >
            <i class="far fa-comment mx-2"></i>123
          </button>
        </div>
      </div>
      <div class="row py-1 mx-0">
        <input-comment v-if="isComment" />
      </div>
      <paylasim-yorum v-for="i in 3" :key="i" />
    </div>
  </article>
</template>

<script>
import PaylasimYorum from "./PaylasimYorum.vue";
import InputComment from "./InputComment.vue";
import ImageDialog from "@/components/Pages/Anasayfa/ImageDialog.vue";
export default {
  components: { PaylasimYorum, ImageDialog, InputComment },
  data() {
    return {
      imagePath: "@/assets/GL_bg.jpg",
      isLike: true,
      isComment: false,
    };
  },
  methods: {
    paylasimBegen() {
      if (this.isLike === true) {
        this.isLike = false;
      } else if (this.isLike === false) {
        this.isLike = true;
      }
    },
    showComment() {
      this.isComment = true;
    },
  },
};
</script>

<style scoped>
.btn:focus,
.btn:active {
  border-color: #0dcaf0;
  outline: #0dcaf0 !important;
  /* box-shadow: none !important; */
}
</style>
